<template>
  <div class="layout-inner program_guide careers">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content">

        <template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>

        <template v-else>

          <template v-if="career && career.name">
            <career-title :career="career"></career-title>
          </template>

          <div class="container-fluid flex-grow-1 pg_content_container">
            <div class="">
              <div class="container">

                <div v-if="career.majors && career.majors.length > 0">
                  <div v-for="major in career.majors" class="">

                    <div class="row result_row">

                      <div class="col-2 thumbnail_container" @click.stop.prevent="goToProgramGuideDetail(major)">
                        <div class="thumbnail thumbnail_container" v-if="major.thumbnailURL">
													<img v-bind:src="major.thumbnailURL" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.png';">
												</div>
                        <div class="thumbnail_default_name" v-if="!major.thumbnailURL" :style="{background:setThumbnailBgColor(major.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(major.title)"></div>
                        </div>
                      </div>

                      <div class="col-10 entity_details">
                        <div class="row">
                          <div class="label" style="width: 95%;">
                            <a class="title" href="javascript://" @click.stop.prevent="goToProgramGuideDetail(major)" style="font-size: 16px; margin-left: 6px; display: block; margin-top: 5px;">
                              {{major.title}}
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

                <div v-else class="mt-5">
                  <div class="text-center">
                    <h4>No programs available for this career</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </template>

        <career-footer-navbar :pageTitle="'Programs'" :returnTo="'careerHome'" :params="{code: code, isComingFromBookmark: isComingFromBookmark}"></career-footer-navbar>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import Navbar from '../../misc/components/./Navbar'
  import CareerFooterNavbar from '../../misc/components/./CareerFooterNavbar'
  import VClamp from 'vue-clamp'

  export default {
    name: 'career-programs',
    props: ['code', 'isComingFromBookmark'],
    components: {
      Navbar,
      CareerTitle,
      CareerFooterNavbar,
      VClamp
    },
    data: () => {
      return {
        isLoading: true
      }
    },

    mounted () {
      this.loadDataForCareerPrograms()
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'loadUserObj'
      ]),
      async loadDataForCareerPrograms () {
        await this.loadUserObj()
        await this.loadCareer(this.code)
        this.isLoading = false
      },
      setTitleInitials (streamTitle) {
        let getTitleInitials = streamTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      setThumbnailBgColor (entityId) {
        let getNumricValue = entityId.replace(/[^0-9]/g, '')
        return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
      },
      goToProgramGuideDetail (major) {
        let routerParams = {
          code: this.code,
          cipCode: major.cipCode,
          programGuideCode: major.code,
          type: major.type,
          isComingFromBookmark: this.isComingFromBookmark
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams, query: {returnTo: 'careerPrograms', pageTitle: 'Programs'}})
      },
      hideUserNamePopup () {
        this.$refs.userNamePopupContainer.$emit('close')
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'career': state => state.career.careerObject
      })
    }
  }
</script>

<style scoped>
  .hd_bdr {
    width: 75px;
    height: 2px;
    float: left;
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
    background-color: #345237;
  }
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerPrograms.vue